<template>
  <div>
    <v-chip :pill="pill" :color="bgColor" :text-color="txtColor" :class="classes">
        <v-icon v-if="icon && iconPosition !== '' && iconPosition === 'left'">
            {{ iconText }}
        </v-icon>
        {{ label }}
        <v-icon v-if="icon && iconPosition !== '' && iconPosition === 'right'">
           {{ iconText }}
        </v-icon>
    </v-chip>
  </div>
</template>
<script>
export default {
  name: "CustomChip",
  props: {
    label: {
      type: String,
      default: "Default",
    },
    bgColor: {
      type: String,
      default: "primary",
    },
    txtColor: {
      type: String,
      default: "white",
    },
    icon: {
      type: Boolean,
      default: false,
    },
    iconText: {
        type: String,
        default: '',
    },
    iconPosition: {
        type: String,
        default: '',
    },
    classes: {
        tpye: String,
        default: '',
    },
    pill: {
      type: Boolean,
      default: false
    }
  },
};
</script>